<template>
    <div>
        <BaseSpinner
            v-if="pending && !isSlug"
            class="video-page__spinner"
        />
        <PageTemplateVideo v-else-if="isSlug" />
        <PageTemplateNotFound v-else-if="!isSlug" />
    </div>
</template>

<script setup>
const router = useRouter();
const route = useRoute();

const { data, execute, pending } = await useAsyncQuery({
    query: `query Video($id: ID!) {
              video(id: $id) {
                slug
              }
            }`,
    variables: { id: route.params.slug[0] }
}, {
    immediate: false
});

// if the slug matches the format of UUIDv4, then it's the ID!
const isSlug = computed(() => {
    return !route?.params?.slug?.[0]?.match(/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/i);
});

onMounted(async() => {
    if (!isSlug.value) {
        await execute();
        
        if (data.value?.video?.slug) {
            await router.push({ name: 'videos-slug', params: { slug: [data.value.video.slug] } });
        }
    }
});
</script>
